import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

export function queryPersonListPage(obj) {
  return request({
    url: urlPrefix + '/payGroupSetting/queryPersonListPage',
    method: 'POST',
    data: obj,
  });
}
export function queryEmpListPage(obj) {
  return request({
    url: urlPrefix + '/attachmentManage/queryEmpListPage',
    method: 'POST',
    data: obj,
  });
}
//获取cusId机构数据,treeSelect
export function queryOrgTreeSelect() {
  return request({
    url: urlPrefix + '/attachmentManage/treeSelect',
    method: 'get',
  });
}
export function saveWageAttachEmp(obj) {
  return request({
    url: urlPrefix + '/attachmentManage/saveWageAttachEmp',
    method: 'post',
    data: obj,
  });
}
export function uploadAttachMent(obj) {
  return request({
    url: urlPrefix + '/attachmentManage/uploadAttachMent',
    method: 'post',
    data: obj,
  });
}
export function savePublicEmp(obj) {

  return request({
    url: urlPrefix + '/attachmentManage/savePublicEmp',
    method: 'post',
    data: obj,
  });
}
export function deleteAttachMent(obj) {
  return request({
    url: urlPrefix + '/attachmentManage/deleteAttachMent',
    method: 'post',
    data: obj,
  });
}

export function deleteEmpAndAttachInfo(obj) {
  return request({
    url: urlPrefix + '/attachmentManage/deleteEmpAttachInfo',
    method: 'post',
    data: obj,
  });
}


